import { Box } from "@mui/material";

import { FrmFieldGrid } from "components/FrmFieldGrid";
import { FrmSelectScalarWithObjectOptionsWithHoverHelp } from "components/formFields/FrmSelectScalarWithObjectOptions";
import { FrmCheckboxWithHoverHelp } from "components/formFields/frm/FrmCheckboxWithHoverHelp";

import { i18n } from "services/i18nService";
import {
  SEND_FOR_SKU_OPTIONS,
  SEND_FOR_DESCRIPTION_OPTIONS,
} from "services/sosInventoryService/settings/connections/shipStation/schema";

export function ShipStation(props) {
  const { value, onValueChange, name } = props;

  function handleValueChange(fieldName, newValue) {
    onValueChange(name, { ...value, [fieldName]: newValue });
  }

  return (
    <Box
      sx={{
        "& .MuiAutocomplete-root": { top: "unset" },
        backgroundColor: "inherit",
      }}
    >
      <FrmFieldGrid>
        <FrmCheckboxWithHoverHelp
          name="enabled"
          value={value.enabled}
          onValueChange={handleValueChange}
          label={i18n("frmLabel.Enabled")}
          helpText={i18n("hoverHelp.ShipStation.enabled")}
        />
        <FrmSelectScalarWithObjectOptionsWithHoverHelp
          selectProps={{
            name: "sendForSku",
            label: i18n("frmLabel.SendForSku"),
            value: value.sendForSku,
            onValueChange: handleValueChange,
            options: SEND_FOR_SKU_OPTIONS,
            minWidth: "24rem",
            disableClearable: true,
          }}
          helpText={i18n("hoverHelp.ShipStation.sendForSku")}
        />
        <FrmSelectScalarWithObjectOptionsWithHoverHelp
          selectProps={{
            name: "sendForDescription",
            label: i18n("frmLabel.SendForDescription"),
            value: value.sendForDescription,
            onValueChange: handleValueChange,
            options: SEND_FOR_DESCRIPTION_OPTIONS,
            minWidth: "24rem",
            disableClearable: true,
          }}
          helpText={i18n("hoverHelp.ShipStation.sendForDescription")}
        />
      </FrmFieldGrid>
    </Box>
  );
}
